
// @ts-nocheck
import locale_en_46json_14a2d1ca from "#nuxt-i18n/14a2d1ca";
import locale_pt_45BR_46json_8d66c7c9 from "#nuxt-i18n/8d66c7c9";
import locale_de_46json_80639611 from "#nuxt-i18n/80639611";
import locale_es_46json_46e31476 from "#nuxt-i18n/46e31476";
import locale_ro_46json_61bcf718 from "#nuxt-i18n/61bcf718";
import locale_ar_45AE_46json_e07d6e36 from "#nuxt-i18n/e07d6e36";

export const localeCodes =  [
  "en",
  "pt-BR",
  "de",
  "es",
  "ro",
  "ar-AE"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_14a2d1ca",
      load: () => Promise.resolve(locale_en_46json_14a2d1ca),
      cache: true
    }
  ],
  "pt-BR": [
    {
      key: "locale_pt_45BR_46json_8d66c7c9",
      load: () => Promise.resolve(locale_pt_45BR_46json_8d66c7c9),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_80639611",
      load: () => Promise.resolve(locale_de_46json_80639611),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_46e31476",
      load: () => Promise.resolve(locale_es_46json_46e31476),
      cache: true
    }
  ],
  ro: [
    {
      key: "locale_ro_46json_61bcf718",
      load: () => Promise.resolve(locale_ro_46json_61bcf718),
      cache: true
    }
  ],
  "ar-AE": [
    {
      key: "locale_ar_45AE_46json_e07d6e36",
      load: () => Promise.resolve(locale_ar_45AE_46json_e07d6e36),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: false,
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en",
      files: [
        {
          path: "/app/lang/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt-BR",
      language: "pt-BR",
      files: [
        {
          path: "/app/lang/pt-BR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      language: "de",
      files: [
        {
          path: "/app/lang/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      language: "es",
      files: [
        {
          path: "/app/lang/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ro",
      language: "ro",
      files: [
        {
          path: "/app/lang/ro.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ar-AE",
      language: "ar",
      dir: "rtl",
      files: [
        {
          path: "/app/lang/ar-AE.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_and_default",
  lazy: false,
  langDir: "./lang",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: true,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  fallbackLocale: [
    "en",
    "pt-BR",
    "de",
    "es",
    "ro",
    "ar-AE"
  ],
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en",
    files: [
      {
        path: "/app/lang/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt-BR",
    language: "pt-BR",
    files: [
      {
        path: "/app/lang/pt-BR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    language: "de",
    files: [
      {
        path: "/app/lang/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    language: "es",
    files: [
      {
        path: "/app/lang/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ro",
    language: "ro",
    files: [
      {
        path: "/app/lang/ro.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ar-AE",
    language: "ar",
    dir: "rtl",
    files: [
      {
        path: "/app/lang/ar-AE.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/